import React from 'react';
import ModalIcon from '../../Icon/Icon';
import CloseButton from '../../CloseButton/CloseButton';
import Title from '../../Title/Title';
import Button from '../../Button/Button';
import { getTranslation } from '../../../../../utils/translation';
import InfoMessage from '../../InfoMessage/InfoMessage';

const Feedback = ({
    title,
    description,
    buttonText,
    onClose,
    icon,
    onOk,
    onRetry,
    showRetryButton,
}) => {
    const handleOk = () => {
        onClose();

        if (onOk) {
            onOk();
        }
    };

    return (
        <>
            {!showRetryButton && <CloseButton onClick={onClose} />}
            {icon && <ModalIcon iconKey={icon} />}
            <Title>{title}</Title>
            <InfoMessage>{description}</InfoMessage>
            <div className={'flex justify-center m-t-20'}>
                {showRetryButton ? (
                    <Button
                        type='default'
                        onClick={onRetry}
                        className={'m-r-4'}
                        width='183px'
                        title={getTranslation('errorModalRetryButton')}
                    />
                ) : (
                    <Button type='primary' onClick={handleOk} width='183px' title={buttonText} />
                )}
            </div>
        </>
    );
};

export default Feedback;
